import { useToastNotification } from '../../components/ToastNotifications';

export const useToasts = () => {
    const { openToast } = useToastNotification();

    const showSuccessToast = (message) => {
        openToast( message, 'success');
    };

    const showErrorToast = (message) => {
        openToast( message, 'error' );
    };

    return { showSuccessToast, showErrorToast };
};